import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import HistoryIcon from '@material-ui/icons/History';
import PersonIcon from '@material-ui/icons/Person';
import PropTypes from 'prop-types';
import React from 'react';
import LanguageAvatar from '../../core/LanguageAvatar';
import { globalStyles } from '../style/gstheme';
import withGS from '../withGShoc';
import { isRTL } from '../utils/utils';

const styles = theme => {
    return Object.assign({
        commentInnerText: {
            fontSize: 14,
            lineHeight: '20px',
            padding: 0
        },
        commentText: {
            color: theme.palette.primary.main,
            fontWeight: 500,
            marginTop: 12,
            marginBottom: 12,
            '& fieldset': {
                border: 'none'
            }
        },
        suggestionInfo: {
            fontSize: 12,
            letterSpacing: '0.36px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'left'
        },
        suggestionIcon: {
            color: '#9E9E9E',
            height: 16,
            verticalAlign: 'bottom'
        }
    }, globalStyles);
};

class DiscussionItem extends React.Component {

    render() {

        const { classes, data, users } = this.props;
        const { comment, created, user } = data;
        const userId = Array.isArray(user) ? user[0] : user;
        const date = created ? new Date(created) : null;
        const dateText = date ? date.toLocaleString() : "Recent";
        const userData = users.find(user => user.value === userId);
        const userText = userData ?
            userData.label
            :
            "User not available";
        const commentLang = Object.keys(comment)[0];
        const rtl = isRTL(commentLang);

        return (
            <div data-test="discussion-comment">
                <div className={classes.suggestionInfo}>
                    <div>
                        <LanguageAvatar data-test="comment-lang" lang={commentLang} />
                    </div>
                    <div data-test="comment-user">
                        <PersonIcon className={classes.suggestionIcon} />
                        {userText}
                    </div>
                    <div data-test="comment-date" style={{ paddingLeft: 12 }}>
                        <HistoryIcon className={classes.suggestionIcon} />
                        {dateText || "Recent"}
                    </div>
                </div>
                <TextField
                    multiline={true}
                    variant={"outlined"}
                    fullWidth={true}
                    InputProps={{
                        inputProps: {
                            "data-test": "comment-text",
                            "aria-label": "Comment text",
                            ...(rtl) && { dir: "rtl" },
                            "lang": commentLang
                        },
                        className: classes.commentInnerText
                    }}
                    className={classes.commentText}
                    value={comment[commentLang]} />
            </div>
        );
    }
}

DiscussionItem.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    users: PropTypes.array.isRequired
};

export default withStyles(styles)(withGS(DiscussionItem, ["ALL"], null, {}));